module.exports = __webpack_public_path__ + "media/images/contest-label-center-27522707d232ed404522f647119ac883.png";